import React from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, Building2, BadgeCheck, Check, SlidersHorizontal, Mail, Phone, Lock, Star, FileText, Copy, ChevronDown, TrendingUp, Users, Send, MessageSquare, FolderKanban } from 'lucide-react';
// Platform Icons
const TTIco = () => <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1248.png" alt="TikTok" className="w-3.5 h-3.5 inline-block" data-id="element-1441" data-mp="1fpq7nwhm03sx" />;
const IGIco = () => <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1249.png" alt="Instagram" className="w-3.5 h-3.5 inline-block" data-id="element-1442" data-mp="28d2lni9pf3am" />;
const WindowBar = ({
  title,
  approved = false
}: {
  title: string;
  approved?: boolean;
}) => <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50/70" data-id="element-1443" data-mp="2w2n3tyy19wiu">
    <div className="flex items-center gap-1.5" data-id="element-1444" data-mp="2rc6r6h21eexj">
      <span className="w-2.5 h-2.5 rounded-full bg-red-400/70" data-id="element-1445" data-mp="2rbev754j2f6q" />
      <span className="w-2.5 h-2.5 rounded-full bg-amber-400/70" data-id="element-1446" data-mp="3cjdz2uxct5c9" />
      <span className="w-2.5 h-2.5 rounded-full bg-emerald-400/70" data-id="element-1447" data-mp="3cm9vufxgtnz4" />
    </div>
    <span className="ml-2 text-xs font-semibold text-gray-500" data-id="element-1448" data-mp="3hi7cyogjyycy">{title}</span>
    {approved && <span className="ml-auto inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-gray-100 text-gray-500 text-[9px] font-semibold uppercase tracking-wider" data-id="element-1449" data-mp="32tkwgjf6w0k5">
        <Lock size={8} data-id="element-1450" data-mp="2tt6ariybcjg4" /> Approved Access
      </span>}
  </div>;
const floatY = (delay = 0, distance = 8) => ({
  animate: {
    y: [0, -distance, 0]
  },
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: 'easeInOut' as const,
    delay
  }
});
export const LayeredPartnerRosterMockup = () => {
  const creators = [{
    name: 'David Kim',
    cat: 'Tech',
    followers: '3.1M',
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=160&h=160'
  }, {
    name: 'Sarah Jenkins',
    cat: 'Lifestyle',
    followers: '890K',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=160&h=160'
  }, {
    name: 'Marcus Chen',
    cat: 'Gaming',
    followers: '1.5M',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&h=160'
  }, {
    name: 'Elena Rodriguez',
    cat: 'Beauty',
    followers: '1.2M',
    photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=160&h=160'
  }];
  return <div className="relative h-[440px] w-full" data-id="element-1451" data-mp="umhfeotihsl7">
      <div className="absolute -inset-6 bg-gradient-to-tr from-purple-100/40 via-zano-lavender/30 to-blue-100/20 rounded-[2.5rem] blur-2xl -z-10" data-id="element-1452" data-mp="ul6c0q3zamum" />
      <div className="absolute inset-0 bg-white rounded-2xl border border-gray-200 shadow-float overflow-hidden flex flex-col text-left" data-id="element-1453" data-mp="1n2s4in5x0wq8">
        <WindowBar title="Partner Rosters" approved data-id="element-1454" data-mp="1ib0ov7oasbev" />

        <div className="p-4 border-b border-gray-100 bg-gray-50/30" data-id="element-1455" data-mp="1ia8v82e9gnr8">
          <div className="flex items-center gap-3" data-id="element-1456" data-mp="1qmiuxq65uuf3">
            <div className="w-10 h-10 bg-gray-900 text-white rounded-lg flex items-center justify-center text-xs font-bold shadow-sm" data-id="element-1457" data-mp="1ulrpgx90ywbp">
              ABC
            </div>
            <div data-id="element-1458" data-mp="1znqs24wxxp7l">
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1459" data-mp="24k7ij5rm4fnu">
                ABC Talent Agency
              </h3>
              <p className="text-[11px] text-gray-500 flex items-center gap-1 mt-0.5" data-id="element-1460" data-mp="29kdcwtp9og9m">
                <Users size={10} data-id="element-1461" data-mp="2dkngjzpl6ulb" /> 142 Exclusive Creators
              </p>
            </div>
          </div>
        </div>

        <div className="p-4 pb-4 grid grid-cols-2 gap-3 overflow-hidden" data-id="element-1462" data-mp="2icx4ja755kky">
          {creators.map((c, i) => <div key={i} className="border border-gray-100 rounded-xl p-3 bg-white hover:border-purple-300/50 transition-colors" data-id="element-1463" data-mp="2n9nkzymuyi6w" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-1464" data-mp="2x8d23p6xjym3">
                <img src={c.photo} alt={c.name} className="w-11 h-11 rounded-full object-cover" data-id="element-1465" data-mp="2x6s75ygpednp" />
                <div className="min-w-0" data-id="element-1466" data-mp="3p0x6fym992ka">
                  <p className="text-xs font-semibold text-gray-900 truncate" data-id="element-1467" data-mp="7kysa1cj8729">
                    {c.name}
                  </p>
                  <p className="text-[10px] text-gray-500" data-id="element-1468" data-mp="2llwus7lhro2">{c.cat}</p>
                </div>
              </div>
              <div className="flex items-center justify-between mt-2.5" data-id="element-1469" data-mp="3b2qf71bta0tl">
                <span className="flex items-center gap-1 text-[10px] font-medium text-gray-600" data-id="element-1470" data-mp="363434v7pyqmd">
                  <TTIco data-id="element-1471" data-mp="3k2vbogfgvesz" /> {c.followers}
                </span>
                <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold text-emerald-600" data-id="element-1472" data-mp="3k096gng1tbdx">
                  <BadgeCheck size={9} data-id="element-1473" data-mp="3g34p6owz3ku9" /> Exclusive
                </span>
              </div>
            </div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="absolute -top-4 -right-4 sm:-right-6 z-20" data-id="element-1474" data-mp="v9hqtp5s55h5">
        <motion.div {...floatY(0.2)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-48" data-id="element-1475" data-mp="xuzamv145u56">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-1476" data-mp="1lmmrek4nvotq">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-1477" data-mp="1qilc9xqs6ope" />
            <p className="text-[11px] font-bold text-gray-900" data-id="element-1478" data-mp="1bv9xlmzayol2">
              Live Sync Active
            </p>
          </div>
          <p className="text-[10px] text-gray-500 leading-snug" data-id="element-1479" data-mp="1gsijnynkncrl">
            Roster updates automatically. No more asking for PDFs.
          </p>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="absolute -bottom-5 -left-4 sm:-left-6 z-20" data-id="element-1480" data-mp="29b60v2zg67ne">
        <motion.div {...floatY(0.9)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-52" data-id="element-1481" data-mp="256bw6unxv0q6">
          <div className="flex items-center gap-2 mb-2" data-id="element-1482" data-mp="209bpchj9lty0">
            <div className="p-1.5 bg-purple-50 rounded-md" data-id="element-1483" data-mp="1vfh95o2vbx3o">
              <FolderKanban size={12} className="text-purple-600" data-id="element-1484" data-mp="1qhfgqcjjylfj" />
            </div>
            <p className="text-[11px] font-bold text-gray-900" data-id="element-1485" data-mp="1qf2zy2pj6h42">
              Client Campaign
            </p>
          </div>
          <button className="w-full bg-gray-900 text-white text-[10px] font-semibold py-1.5 rounded-md" data-id="element-1486" data-mp="1hghkigfcvi7i">
            Add to shortlist
          </button>
        </motion.div>
      </motion.div>
    </div>;
};
export const LayeredAListWedgeMockup = () => {
  return <div className="relative h-[440px] w-full" data-id="element-1487" data-mp="3o744i42zsg7z">
      <div className="absolute -inset-6 bg-gradient-to-tr from-amber-100/40 via-zano-pink/20 to-zano-lavender/30 rounded-[2.5rem] blur-2xl -z-10" data-id="element-1488" data-mp="3t3bcs3iv23t3" />
      <div className="absolute inset-0 bg-white rounded-2xl border border-gray-200 shadow-float overflow-hidden flex flex-col text-left" data-id="element-1489" data-mp="1vp23qxq512q">
        <WindowBar title="Roster Database" approved data-id="element-1490" data-mp="35f1vnewle48a" />
        <div className="p-4" data-id="element-1491" data-mp="35gcx382kezw8">
          <div className="relative w-full" data-id="element-1492" data-mp="3admminpyfbk2">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zano-pink" data-id="element-1493" data-mp="3aeegxv7tf38r" />
            <div className="w-full pl-9 pr-3 py-2.5 border-2 border-zano-pink/40 rounded-lg text-sm font-medium text-gray-900 bg-white shadow-sm" data-id="element-1494" data-mp="3eddh72ilqbtv">
              Michelle Brown
            </div>
          </div>
          <p className="text-[11px] text-gray-400 mt-2 mb-3" data-id="element-1495" data-mp="2qpm5o14vy2tn">1 result</p>

          <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1496" data-mp="2qnsvwcyz72hf">
            <div className="p-4 flex items-center gap-3 border-b border-gray-100" data-id="element-1497" data-mp="1k333qlklb1ep">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=120&h=120" alt="Michelle Brown" className="w-14 h-14 rounded-full object-cover" data-id="element-1498" data-mp="1f49w39rzi4mg" />
              <div className="min-w-0" data-id="element-1499" data-mp="1p3r0lnvi2cgu">
                <h3 className="text-base font-bold text-gray-900 leading-tight" data-id="element-1500" data-mp="230e283yedqt3">
                  Michelle Brown
                </h3>
                <div className="flex items-center gap-2 mt-1" data-id="element-1501" data-mp="1y1syhujxsozw">
                  <span className="flex items-center gap-1 text-[11px] font-medium text-gray-600" data-id="element-1502" data-mp="2cpxid1uq76k9">
                    <TTIco data-id="element-1503" data-mp="27sxcaqxvm3t5" /> 8.4M
                  </span>
                  <span className="flex items-center gap-1 text-[11px] font-medium text-gray-600" data-id="element-1504" data-mp="2lrn905gsa1gz">
                    <IGIco data-id="element-1505" data-mp="2hq216yj3wddn" /> 3.1M
                  </span>
                </div>
              </div>
            </div>
            <div className="p-4" data-id="element-1506" data-mp="30em01zbqatv6">
              <div className="flex items-center gap-2 mb-2" data-id="element-1507" data-mp="30fnmt123x4sq">
                <div className="w-7 h-7 bg-gray-900 text-white rounded-md flex items-center justify-center text-[9px] font-bold" data-id="element-1508" data-mp="35d6ypubc15hi">
                  ABC
                </div>
                <span className="text-sm font-bold text-gray-900" data-id="element-1509" data-mp="2rg0j28lwnmwi">
                  ABC Talent Agency
                </span>
                <span className="ml-auto inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[10px] font-semibold" data-id="element-1510" data-mp="2ho4hgnkm1enj">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-1511" data-mp="2mfw1sgd6ao58" />
                  Exclusive
                </span>
              </div>
              <div className="space-y-2 mt-3" data-id="element-1512" data-mp="2co9v8xbs5d8t">
                <p className="text-[9px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1513" data-mp="2cp1f5aw0lmj9">
                  Talent manager · John Smith
                </p>
                <div className="flex items-center justify-between gap-2 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1.5" data-id="element-1514" data-mp="23oczycuvxg4s">
                  <span className="flex items-center gap-2 text-xs font-medium text-gray-700 truncate" data-id="element-1515" data-mp="1qk6gogb10c3a">
                    <Mail size={12} className="text-gray-400 shrink-0" data-id="element-1516" data-mp="1uoe9opoioe7b" />
                    john@abctalentagency.com
                  </span>
                  <Copy size={12} className="text-gray-400 shrink-0" data-id="element-1517" data-mp="1llv786on83ll" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="absolute -top-4 -right-3 sm:-right-5 z-20" data-id="element-1518" data-mp="29e27vi1eiwqt">
        <motion.div {...floatY(0.3, 6)} className="flex items-center gap-1.5 bg-white rounded-full border border-amber-200 shadow-[0_15px_35px_-12px_rgba(0,0,0,0.2)] pl-2 pr-3 py-1.5" data-id="element-1519" data-mp="2s98vtzmt1ovy">
          <span className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-1520" data-mp="lkqaofi7mzow">
            <Star size={12} className="fill-amber-500 text-amber-500" data-id="element-1521" data-mp="gn84gwvkuykl" />
          </span>
          <span className="text-[11px] font-bold text-amber-700" data-id="element-1522" data-mp="ued7m8y5m8zo">
            A-List Access
          </span>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.6
    }} className="absolute bottom-2 -left-4 sm:-left-6 z-20" data-id="element-1523" data-mp="2nfdr1k1wicm">
        <motion.div {...floatY(1.1)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-48" data-id="element-1524" data-mp="6nzesg7qw641">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-1525" data-mp="1i3o0735cox2q">
            <span className="w-1.5 h-1.5 rounded-full bg-purple-500" data-id="element-1526" data-mp="frb8dc47wrl7" />
            <p className="text-[10px] font-bold text-gray-900" data-id="element-1527" data-mp="ft5nuawpzrhw">
              Your Agency's Wedge
            </p>
          </div>
          <p className="text-[10px] text-gray-500 leading-snug" data-id="element-1528" data-mp="orzg5p30pvpn">
            Impress clients with direct access to the highest level of creators.
          </p>
        </motion.div>
      </motion.div>
    </div>;
};
export const LayeredAgencyOutreachMockup = () => {
  return <div className="relative h-[440px] w-full" data-id="element-1529" data-mp="3t44n5fp5q1it">
      <div className="absolute -inset-6 bg-gradient-to-tr from-sky-100/40 via-zano-lavender/30 to-zano-pink/10 rounded-[2.5rem] blur-2xl -z-10" data-id="element-1530" data-mp="136o43pio80b" />
      <div className="absolute inset-0 bg-white rounded-2xl border border-gray-200 shadow-float overflow-hidden flex flex-col text-left" data-id="element-1531" data-mp="5zeyz4wolf1o">
        <WindowBar title="Campaign Sourcing" data-id="element-1532" data-mp="39iqemuyszcbo" />
        <div className="p-4 space-y-4 overflow-hidden" data-id="element-1533" data-mp="39hotfxo2p9g8">
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3" data-id="element-1534" data-mp="3eg9rprjrlj21">
            <div className="flex items-center gap-2 mb-2" data-id="element-1535" data-mp="36xa93o44nvjq">
              <MessageSquare size={14} className="text-zano-pink" data-id="element-1536" data-mp="36wr1b086ynjf" />
              <span className="text-xs font-bold text-gray-900" data-id="element-1537" data-mp="31zh613y4fhno">
                Direct Email
              </span>
            </div>
            <div className="bg-white border border-gray-200 rounded-md p-2.5" data-id="element-1538" data-mp="2wxjhpvav5wnv">
              <p className="text-[10px] text-gray-400 mb-1" data-id="element-1539" data-mp="2sx7vie2uroaa">
                To: john@abctalentagency.com
              </p>
              <p className="text-[10px] text-gray-400 mb-2" data-id="element-1540" data-mp="2o0r9bpf7rjzu">
                Subject: Partnership for Summer Campaign
              </p>
              <p className="text-[10px] text-gray-600 leading-relaxed" data-id="element-1541" data-mp="2e8bpemkcwlcb">
                Hi John, we're casting for a new client campaign and would love
                to partner with your roster...
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-1542" data-mp="257djfyqcy3r3">
            <div className="h-px bg-gray-200 flex-1" data-id="element-1543" data-mp="208k7iaqpykt1" />
            <span className="text-[10px] font-bold text-gray-400 uppercase" data-id="element-1544" data-mp="20b6nmyroe8mv">
              OR
            </span>
            <div className="h-px bg-gray-200 flex-1" data-id="element-1545" data-mp="48beslna6x8i" />
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3" data-id="element-1546" data-mp="870voo7j2www">
            <div className="flex items-center gap-2 mb-2" data-id="element-1547" data-mp="3qkgulzidai2o">
              <Send size={14} className="text-zano-pink" data-id="element-1548" data-mp="3vkmqjrvo6qqk" />
              <span className="text-xs font-bold text-gray-900" data-id="element-1549" data-mp="3vj1vm15g15s6">
                Post Casting Call
              </span>
            </div>
            <div className="bg-white border border-gray-200 rounded-md p-2.5" data-id="element-1550" data-mp="3lmfftqrz54x0">
              <div className="flex justify-between items-center mb-2" data-id="element-1551" data-mp="3lkcielohs9i9">
                <span className="text-[10px] font-semibold text-gray-700" data-id="element-1552" data-mp="37o8pcvpcu77d">
                  Summer Skincare Launch
                </span>
                <span className="text-[10px] text-gray-500" data-id="element-1553" data-mp="15vb3jjtzwevx">$10k - $20k</span>
              </div>
              <button className="w-full bg-zano-pink text-white rounded-md py-1.5 text-[10px] font-bold shadow-sm" data-id="element-1554" data-mp="15tgd5pzyfukg">
                Blast to 400+ Agencies
              </button>
            </div>
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="absolute -top-4 -right-3 sm:-right-6 z-20" data-id="element-1555" data-mp="1g00y34n2kgq4">
        <motion.div {...floatY(0.2)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-48" data-id="element-1556" data-mp="23qn2mlxv7ivd">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-1557" data-mp="2copb1mjxhdso">
            <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-1558" data-mp="28nnc76txb3r8" />
            <p className="text-[11px] font-bold text-gray-900" data-id="element-1559" data-mp="ibhg7uvyd271">
              Happy to Partner
            </p>
          </div>
          <p className="text-[10px] text-gray-500" data-id="element-1560" data-mp="eanqcvyy9dbi">
            Agencies want more brand deals for their talent. They're ready to
            work with you.
          </p>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.55
    }} className="absolute -bottom-6 -left-4 sm:-left-8 z-30" data-id="element-1561" data-mp="2ieryxgcflf4j">
        <motion.div {...floatY(1)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-56" data-id="element-1562" data-mp="31cbcmx9u3lxa">
          <div className="flex items-center gap-2.5 mb-2" data-id="element-1563" data-mp="365e7r9u9f3fl">
            <img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=64&h=64" alt="Submission" className="w-9 h-9 rounded-full object-cover" data-id="element-1564" data-mp="3b1crul8k1za7" />
            <div className="min-w-0" data-id="element-1565" data-mp="3k0ztn857573s">
              <p className="text-[11px] font-bold text-gray-900 truncate" data-id="element-1566" data-mp="18g8q81r3y8lc">
                New submission
              </p>
              <span className="inline-flex items-center gap-1 text-[9px] font-semibold text-emerald-700" data-id="element-1567" data-mp="14d2l4xfqengg">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-1568" data-mp="zfu4x2e58thu" />
                Exclusive · ABC Talent Agency
              </span>
            </div>
          </div>
          <div className="flex justify-between items-center bg-gray-50 rounded-md border border-gray-100 px-2.5 py-1.5" data-id="element-1569" data-mp="1s4859ospg1wk">
            <span className="text-[10px] text-gray-500" data-id="element-1570" data-mp="1n5y7d6flin79">Quote</span>
            <span className="text-xs font-bold text-green-600" data-id="element-1571" data-mp="1iddf49cc8i5u">$1,200</span>
          </div>
        </motion.div>
      </motion.div>
    </div>;
};